import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Logo } from "@/components/Logo";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  // Detect language from pathname
  const isEnglish = location.pathname.startsWith("/en");

  const content = isEnglish
    ? {
        title: "404",
        message: "Sorry, this page could not be found",
        button: "Return to Home",
      }
    : {
        title: "404",
        message: "Því miður, þessi síða fannst ekki",
        button: "Til baka á forsíðu",
      };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-primary/10 via-background to-secondary/10 relative overflow-hidden">
      {/* Decorative blurred gradient circle */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-primary/20 rounded-full blur-3xl -z-10" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-secondary/20 rounded-full blur-3xl -z-10" />
      <div className="text-center max-w-lg mx-auto p-8 bg-background/80 rounded-xl shadow-xl border border-border">
        <div className="flex justify-center mb-6">
          <Logo size="lg" layout="horizontal" />
        </div>
        <h1 className="mb-4 text-6xl font-extrabold text-primary">{content.title}</h1>
        <p className="mb-4 text-xl text-muted-foreground font-medium">{content.message}</p>
        <a href={isEnglish ? "/en" : "/"} className="inline-block mt-4 px-6 py-3 rounded-lg bg-primary text-primary-foreground font-semibold shadow hover:bg-primary/90 transition-colors">
          {content.button}
        </a>
        
      </div>
    </div>
  );
};

export default NotFound;
